import { BaseComponent } from './base.component';
import { RteToolbarViewModel, RTEAlertService, AfterSave, AfterGet } from 'rte-library';
import { AfterContentInit } from '@angular/core';

export abstract class BaseToolBarCRUDComponent<T> extends BaseComponent implements AfterContentInit {

    toolbarObject: RteToolbarViewModel<T> = new RteToolbarViewModel<T>();

    constructor(public alert: RTEAlertService) {
      super();
    }



    ngAfterContentInit() {
      if (this.toolbarObject) {
        setTimeout(() => {

          const component = this.toolbarObject.toolbarComponent;

          if (component) {
            this.subscription.add(component.customizeAfterSave.subscribe(x => this.customizeAfterSave(x)));
            this.subscription.add(component.customizeAfterDelete.subscribe(x => this.customizeAfterDelete(x)));
            this.subscription.add(component.customizeAfterGet.subscribe(x => this.customizeAfterGet(x)));
            this.subscription.add(component.customizeAfterClear.subscribe(x => this.customizeAfterClear()));
          }

        });
      }
    }

    public customizeAfterSave(afterSave: AfterSave) {
      const current: any = this.toolbarObject.current;

      if (afterSave.success && current && current.hasOwnProperty('Revision')) {
        current.Revision ++;
      }

      if (afterSave.success) {
        this.alert.success('Operação realizada com sucesso');
      }
    }

    public customizeAfterDelete(result: boolean) {
      if (result) {
        this.alert.success('Registro excluído com sucesso', '');
      }
    }

    public customizeAfterGet(afterGet: AfterGet) {
      if (!afterGet.success) {
        if (afterGet.data) {
          if ((afterGet.data.hasOwnProperty('length') && afterGet.data.length === 0 ) || (afterGet.data.AmountPages === 0)) {
            this.alert.info('Nenhum registro foi encontrado');
          }
        }
      }
    }

    public customizeAfterClear() {
      setTimeout(() => {
        const current: any = this.toolbarObject.current;

        if (current) {
          Object.assign(this.toolbarObject.searchObject, this.toolbarObject.current);
        }
      });
    }
}
